// Projects data.
// Note: Here we are getting data from a js file, but in a different project I'll be fetching these projects from some srt of APIs.

const projects = [
	{
		id: 20,
		slug: 'fsfs',
		title: 'FSFS',
		category: 'App',
		coverStyle: 'screens',
		img: require('@/assets/images/fsfs/logo.jpg'),
		date: 'Aug, 2026',
		details: 'A Telegram mini-app for meeting new people — swipe, match, and chat.',
		description: 'fsfs — "find someone for something" — lets you build a profile, swipe through people nearby, and start chatting the moment you match. It runs natively inside Telegram, so there\'s no app to install: open the bot and you\'re in. Supports multiple profiles and a PRO tier for extra visibility.',
		platform_name: 'Telegram',
		website: 'https://t.me/tryfsfsbot?startapp',
		techs: [
			'Next.js',
			'React',
			'TypeScript',
			'Telegram Mini App',
		],
		imgs: [
			require('@/assets/images/fsfs/screen-swipe.jpg'),
			require('@/assets/images/fsfs/screen-profile.jpg'),
			require('@/assets/images/fsfs/screen-matches.jpg'),
		],
	},
	{
		id: 21,
		slug: 'afsfs',
		title: 'AFSFS',
		category: 'App',
		img: require('@/assets/images/afsfs/cover.png'),
		date: 'Sep, 2026',
		details: 'A dating service usable only through AI agents — no photos, bios, or UI, just vectors.',
		description: 'afsfs — "agentic find someone for something" — never receives your words or photos, only the vectors an agent computes from them. There\'s no feed, no bios, no app for humans to browse: message the bot for an invite code, hand it to your agent, and the agent does the searching from there. Matches are mutual-consent — a Telegram handle is revealed only once both sides like each other — and one call deletes a profile entirely, though reports and spent invite codes survive it on purpose.',
		platform_name: 'Website',
		website: 'https://afsfs.anrealm.net',
		techs: [
			'Python',
			'FastAPI',
			'Telegram Bot API',
		],
		imgs: [
			require('@/assets/images/afsfs/cover.png'),
			require('@/assets/images/afsfs/screen-human.png'),
			require('@/assets/images/afsfs/screen-agent.png'),
		],
	},
	{
		id: 22,
		slug: 'moto-charts',
		title: 'moto-charts',
		category: 'Browser Extension',
		img: require('@/assets/images/moto-charts/cover.png'),
		date: 'Sep, 2026',
		details: 'A physics bike game played on your own data — ride a motorbike over any chart line.',
		description: 'moto-charts turns the line of any on-page chart into rideable terrain. It knows nothing about the charting library — it pulls the path straight out of the SVG DOM, so it works on Highcharts, D3, ECharts, Plotly, anything that renders as SVG. Pick the line you want, then ride it as a motorbike track, cliffs, spikes and all, with three modes trading fidelity to the original shape for how completable the climbs are. Ships as a browser extension, a bookmarklet, or a standalone demo page.',
		platform_name: 'GitHub',
		website: 'https://github.com/anrealm/moto-charts',
		techs: [
			'JavaScript',
			'Canvas',
			'SVG',
			'WebExtensions',
		],
		imgs: [
			require('@/assets/images/moto-charts/picker.png'),
			require('@/assets/images/moto-charts/cover.png'),
			require('@/assets/images/moto-charts/ride.png'),
		],
	},
	{
		id: 10,
		slug: 'border-collie',
		title: 'Border Collie: Sheep Dog',
		category: 'Web Games',
		img: require('@/assets/images/border_collie/border-collie.png'),
		date: 'Oct, 2023',
		details: 'An arcade game where you control a border collie.',
		description: 'Border Collie: Sheep Dog puts you in control of a sheepdog on a working farm, ' +
						'herding every sheep into the pen while testing your dog-handling skills. 🐶🐑',
		platform_name: 'Yandex Games',
		website: 'https://yandex.com/games/app/259104',
		techs: [
			'Unity',
			'C#',
		],
		imgs: [
			require('@/assets/images/border_collie/gluck1.png'),
			require('@/assets/images/border_collie/gluck2.png'),
			require('@/assets/images/border_collie/gluck3.png'),
		]
	},
	{
		id: 11,
		slug: 'pushifka',
		title: 'Puffskein Adventure',
		category: 'Web Games',
		archived: true,
		img: require('@/assets/images/puffskein/puffskein.png'),
		date: 'Jul, 2023',
		details: 'A platform game where you control a fluffy puffskein.',
		description: 'You control a fluffy, big-eyed puffskein on a journey across multiple levels, ' +
						'overcoming obstacles along the way.',
		platform_name: 'Yandex Games',
		website: 'https://yandex.com/games/app/232766',
		techs: [
			'Unity',
			'C#',
		],
		imgs: [
			require('@/assets/images/puffskein/puff1.png'),
			require('@/assets/images/puffskein/puff2.png'),
			require('@/assets/images/puffskein/puff3.png'),
		]
	},
	{
		id: 1,
		slug: 'slica',
		title: 'Slica. Neuro puzzles',
		category: 'Web Games',
		img: require('@/assets/images/slica.jpg'),
		date: 'Dec, 2022',
		details: 'A puzzle game with daily generated pictures from AI.',
		description: 'A neural network generates a new picture every day. Complete the mosaic in as few ' +
						'moves as possible — pick any two cells and they swap places. Once you finish, replay ' +
						'on a harder level or pick another day\'s picture.',
		platform_name: 'Yandex Games',
		website: 'https://yandex.com/games/app/201142',
		techs: [
			'HTML',
			'CSS',
			'JavaScript',
			'Vue.js',		],
		imgs: [
			require('@/assets/images/image_slica_1.png'),
			require('@/assets/images/image_slica_2.png'),
			require('@/assets/images/image_slica_3.png'),
		],
	},
	{
		id: 2,
		slug: 'girls-puzzles-and-anime',
		title: 'Girls, puzzles and anime',
		category: 'Web Games',
		img: require('@/assets/images/anime-slica.jpg'),
		date: 'Jan, 2023',
		details: 'A puzzle game with daily generated pictures of anime girls from AI.',
		description: 'The same daily-mosaic puzzle as Slica, tuned around AI-generated anime portraits. ' +
						'Swap any two cells to rebuild the picture in as few moves as possible, then replay ' +
						'on a harder level or pick another day\'s art.',
		platform_name: 'Yandex Games',
		website: 'https://yandex.com/games/app/210816',
		techs: [
			'HTML',
			'CSS',
			'JavaScript',
			'Vue.js',		],
		imgs: [
			require('@/assets/images/image_anime_slica_1.png'),
			require('@/assets/images/image_anime_slica_2.png'),
			require('@/assets/images/image_anime_slica_3.png'),
		],
	},
	{
		id: 3,
		slug: 'matrix-word',
		title: 'Matrix Word',
		category: 'Web Games',
		archived: true,
		img: require('@/assets/images/matrix-word.jpg'),
		date: 'Feb, 2023',
		details: 'A puzzle game with fill-words mechanics.',
		description: 'Matrix Word is a "collect the word" puzzle: find and fill in as many words as ' +
						'possible hidden across the letter grid, then compare your score with other players.',
		platform_name: 'Yandex Games',
		techs: [
			'HTML',
			'CSS',
			'JavaScript',
			'Vue.js',		],
		imgs: [
			require('@/assets/images/image_matrix_1.png'),
			require('@/assets/images/image_matrix_2.png'),
			require('@/assets/images/image_matrix_3.png'),
		],
	},
	{
		id: 4,
		slug: 'spin-planer-round',
		title: 'Spin Planet Round',
		category: 'Web Games',
		archived: true,
		img: require('@/assets/images/spin-planet.jpg'),
		date: 'Nov, 2022',
		details: 'A "destroy the enemy" arcade game built in Unity.',
		description: 'Destroy as many enemy planets as you can. The mechanics are simple: spin around ' +
						'and throw asteroids at anything in range.',
		platform_name: 'Yandex Games',
		techs: [
			'HTML',
			'CSS',
			'Unity',
			'C#',
		],
		imgs: [
			require('@/assets/images/planet-pic-1.png'),
			require('@/assets/images/planet-pic-2.png'),
			require('@/assets/images/planet-pic-3.png'),
		],
	},
	{
		id: 5,
		slug: 'the-world-after-the-disaster',
		title: 'The world after the disaster',
		category: 'Web Games',
		archived: true,
		img: require('@/assets/images/novelx.jpg'),
		date: 'Jan, 2023',
		details: 'A visual novel about a 200-year-old secret.',
		description: 'A visual novel set in a parallel-universe future. The story follows a secret people ' +
						'have kept for 200 years — help the protagonist uncover the truth before disaster strikes.',
		techs: [
			'HTML',
			'CSS',
			'JavaScript',		],
		imgs: [
			require('@/assets/images/novel-pic-1.png'),
			require('@/assets/images/novel-pic-2.png'),
			require('@/assets/images/novel-pic-3.png'),
		],
	},
	{
		id: 6,
		slug: 'neuro-crocodile',
		title: 'Neuro Crocodile',
		category: 'Web Games',
		img: require('@/assets/images/croco.png'),
		date: 'Apr, 2023',
		details: 'A crocodile classic game with AI as a teammate.',
		description: 'You have 42 seconds to draw a word while a trained model tries to guess it.',
		platform_name: 'Yandex Games',
		website: 'https://yandex.com/games/app/223098',
		techs: [
			'Keras',
			'Tensorflow',
			'Python',
			'HTML',
			'CSS',
			'JavaScript',
			'Vue.js',		],
		imgs: [
			require('@/assets/images/croco-pic-1.png'),
			require('@/assets/images/croco-pic-2.png'),
			require('@/assets/images/croco-pic-3.png'),
		],
	},
	{
		id: 7,
		slug: 'matrix-numbers',
		title: 'Matrix Numbers',
		category: 'Web Games',
		archived: true,
		img: require('@/assets/images/matrix-nums.png'),
		date: 'Apr, 2023',
		details: 'A puzzle about finding numbers that add up to a target sum.',
		description: 'Matrix Numbers is a puzzle where you find groups of numbers scattered across the ' +
						'field that add up to a matching sum.',
		platform_name: 'Yandex Games',
		techs: [
			'HTML',
			'CSS',
			'JavaScript',
			'Vue.js',		],
		imgs: [
			require('@/assets/images/nums-pic-1.png'),
			require('@/assets/images/nums-pic-2.png'),
			require('@/assets/images/nums-pic-3.png'),
		],
	},
];

var map_projects = {};
projects.forEach((x) => {
	map_projects[x.slug] = x;
})

export default projects;
export {map_projects};
